import { DotsThreeVerticalIcon } from "@phosphor-icons/react/dist/csr/DotsThreeVertical";
import { ReactNode } from "react";
import { Button } from "@volca/ui/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@volca/ui/components/ui/dropdown-menu";
import { SimpleSidebarHeader } from "@volca/ui/components/ui/simple-sidebar";
import { cn } from "@volca/ui/lib/utils";

interface DropdownAction {
  label: string;
  onClick: () => void;
  variant?: "default" | "destructive";
}

interface BusinessSettingsSidebarHeaderProps {
  headerText?: string;
  name: string | null;
  onClose: () => void;
  actions?: ReactNode;
  dropdownActions?: DropdownAction[];
  className?: string;
}

export const BusinessSettingsSidebarHeader = ({
  headerText,
  name,
  onClose,
  actions,
  dropdownActions,
  className,
}: BusinessSettingsSidebarHeaderProps) => (
  <SimpleSidebarHeader
    className={cn("px-6", className)}
    title={
      <>
        {headerText && (
          <span
            className="block truncate text-xs font-normal text-subtle"
            title={headerText}
          >
            {headerText}
          </span>
        )}
        {name ?? ""}
      </>
    }
    actions={
      (actions || (dropdownActions && dropdownActions.length > 0)) && (
        <>
          {actions}
          {dropdownActions && dropdownActions.length > 0 && (
            <DropdownMenu>
              <DropdownMenuTrigger
                render={
                  <Button
                    variant="ghost"
                    size="icon"
                    aria-label="More actions"
                    className="ml-auto shrink-0"
                  />
                }
              >
                <DotsThreeVerticalIcon />
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="min-w-max">
                {dropdownActions.map((action, index) => (
                  <DropdownMenuItem
                    key={index}
                    onClick={action.onClick}
                    variant={action.variant}
                  >
                    {action.label}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </>
      )
    }
    onClose={onClose}
  />
);
